<kendo-dialog-titlebar>
    {{'admin-center.header.addNewUser' | translate}}
</kendo-dialog-titlebar>
<form  [formGroup]="addDataForm">
    <app-user-form [form]="addDataForm"></app-user-form>
</form>

<kendo-dialog-actions>
    <button kendoButton (click)="cancel()">{{'global.cancel' | translate}}</button>
    <button  type="button"  kendoButton (click)="confirm()" [primary]="true">
        <span>{{'global.add' | translate}}</span>
    </button>
</kendo-dialog-actions>